/**
 * Extended StyleSheet
 */
import Api from './api';
export default new Api();